import { render, staticRenderFns } from "./CorporateFooter.vue?vue&type=template&id=14232b4e&"
import script from "./CorporateFooter.vue?vue&type=script&lang=js&"
export * from "./CorporateFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports